// 选择器数据源
import { dispatch } from "@rematch/core";
import { CQ } from "utils/commonQuest";
import {
  getSupplier,
  getProductCate,
  getUser,
  getFromSource,
  getAfterSaleReson,
  getAfterSaleType
} from "utils/interface";

import { EOrderListPageType } from "utils/enum/orderListFormEnum";

export const selectorSource = {
  state: {},
  effects: {
    // 获取供应商数据
    async getSupplier(payload: any, rootState: any) {
      // 等待异步调用的结果
      //const data = await _GET(APIS.getSupplier);
      const data = await CQ(getSupplier());
      let supplierData = [];
      try {
        if (data) {
          supplierData = data.map(item => {
            return {
              id: item.id,
              name: item.name
            };
          });
        } else {
          console.error("未获取供应商数据或者返回值的格式不正确", data);
        }
      } catch (error) {
        console.error("未获取供应商数据或者返回值的格式不正确", data);
      }

      dispatch["share"].updateSelectorSource({
        name: "supplier",
        data: supplierData
      });
    },
    // 获取商品分类列表
    async getProductCate(payload: any, rootState: any) {
      // 等待异步调用的结果
      const data = await CQ(getProductCate());

      if (!data) {
        console.error("未获取商品分类列表或者返回值的格式不正确", data);
      }

      dispatch["share"].updateSelectorSource({
        name: "productCate",
        data: data
      });
    },
    // 获取客服列表
    async getUser(payload: any, rootState: any) {
      // 如果有值了，则无需重复请求接口
      if (rootState.share["user"]) {
        return;
      }

      dispatch["share"].updateSelectorSource({
        name: "user",
        data: []
      });

      // 等待异步调用的结果
      //const data = await _GET(APIS.getSupplier);
      const data = await CQ(getUser());
      let _data = [];
      try {
        if (data) {
          _data = data.map(item => {
            return {
              id: item.id,
              name: item.fullname,
              isLock: item.isLock
            };
          });
        } else {
          console.error("未获取供应商数据或者返回值的格式不正确", data);
        }
      } catch (error) {
        console.error("未获取供应商数据或者返回值的格式不正确", data);
      }

      dispatch["share"].updateSelectorSource({
        name: "user",
        data: _data
      });
    },
    // 获取商城订单来源列表
    async getStoreOrderSource(payload: any, rootState: any) {
      const data = await CQ(
        getFromSource({ id: EOrderListPageType.shangcheng })
      );
      const _data = data.map(item => {
        return {
          id: item.id,
          name: item.name
        };
      });

      dispatch["share"].updateSelectorSource({
        name: "storeOrderSource",
        data: _data
      });
    },
    // 获取售后原因
    async getAfterSaleReson(payload: any, rootState: any) {
      const data = await CQ(getAfterSaleReson());
      const _data = data.map(item => {
        return {
          id: item.id,
          name: item.title
        };
      });

      dispatch["share"].updateSelectorSource({
        name: "getAfterSaleReson",
        data: _data
      });
    },
    // 获取售后类型
    async getAfterSaleType(payload: any, rootState: any) {
      const data = await CQ(getAfterSaleType());
      const _data = data.map(item => {
        return {
          id: item.id,
          name: item.title
        };
      });

      dispatch["share"].updateSelectorSource({
        name: "getAfterSaleType",
        data: _data
      });
    }
  }
};
